import Route from '@ember/routing/route';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

import {
  PROFILE_USER_INCLUDES_BUYER,
  PROFILE_USER_INCLUDES_SELLER,
  PROFILE_USER_INCLUDES_SELF,
} from 'sh-www/constants/components/profile';

class ProfileRoute extends Route {
  /** Register services */
  @service('states/application') applicationState;
  @service('state-managers/application') applicationStateManager;
  @service('commands/user-commands') userCommandService;
  @service session;
  @service router;

  /** @inheritDoc */
  get queryParams() {
    return {
      project: { replace: true },
    };
  }

  /** @inheritDoc */
  beforeModel(transition) {
    const { currentUser } = this.session;

    if (!currentUser) {
      const userId = transition.to.params.profileId;

      return this.userCommandService.getUser(userId).then((user) => {
        transition.abort();
        window.location.assign(`/u/${user.publicSlug}/`);
      });
    }

    if (currentUser.funnel) {
      this.router.transitionTo('start');
    }
  }

  /** @inheritDoc */
  model(params) {
    const userID = decodeURIComponent(params.profileId);

    const includes = [
      ...PROFILE_USER_INCLUDES_BUYER,
      ...PROFILE_USER_INCLUDES_SELLER,
    ];

    const { currentUser } = this.session;

    if (currentUser.id === userID || currentUser.slug === userID) {
      includes.push(...PROFILE_USER_INCLUDES_SELF);
    }

    return this.userCommandService
      .getUser(userID, includes)
      .then((user) => ({ user }));
  }

  /** @inheritDoc */
  setupController(controller, model, transition) {
    super.setupController(...arguments);

    controller.blockedDetails = transition.data.blockedDetails;

    if (model.user.isSeller) {
      trackPageViewFromTransition(this, transition, '/profile/:sellerId/');
    } else if (model.user.isBuyer) {
      trackPageViewFromTransition(this, transition, '/profile/:buyerId/');
    }
  }

  /** @inheritDoc */
  @action
  willTransition(transition) {
    if (!this.controller.canTransitionAway()) {
      transition.abort();
      this.controller.runProfileCleanup().then(() => transition.retry());
    }
  }
}

export default ProfileRoute;
